import type { Geometry } from 'geojson';

/** First lon/lat pair in a GeoJSON geometry, for a point, line, or polygon. */
export function firstLatLng(
  geometry: Geometry | null | undefined
): { lat: number; lng: number } | null {
  if (!geometry || geometry.type === 'GeometryCollection') return null;
  return walk(geometry.coordinates);
}

function walk(value: unknown): { lat: number; lng: number } | null {
  if (!Array.isArray(value) || value.length === 0) return null;
  if (typeof value[0] === 'number' && typeof value[1] === 'number') {
    return { lng: value[0], lat: value[1] };
  }
  for (const child of value) {
    const point = walk(child);
    if (point) return point;
  }
  return null;
}

/** "lat, lng" when both numbers are in range. */
export function parseLatLng(
  query: string
): { lat: number; lng: number } | null {
  const match = query
    .trim()
    .match(/^(-?\d+(?:\.\d+)?)\s*,\s*(-?\d+(?:\.\d+)?)$/);
  if (!match) return null;
  const lat = Number(match[1]);
  const lng = Number(match[2]);
  if (lat < -90 || lat > 90 || lng < -180 || lng > 180) return null;
  return { lat, lng };
}
